import {useState, useEffect} from "react"
import {useAuthContext} from "./useAuthContext"
import {user} from "../context/AuthContext"
import {API_URL} from "../constants"

export default function useLogin() {
   const [isCancelled, setIsCancelled] = useState(false)
   const [error, setError] = useState<null | string>(null)
   const [isPending, setIsPending] = useState(false)
   const {dispatch} = useAuthContext()

   const login = async (email: string, password: string, origin: string) => {
      setIsPending(true)

      try {
         const response = await fetch(`${API_URL}/usuarios/login`, {
            method: "POST",
            mode: "cors",
            headers: {
               "Content-Type": "application/json",
               Origin: origin,
            },
            credentials: "include",
            body: JSON.stringify({email, password}),
         })
         const parsedRes = await response.json()
         const userInfo: user = {
            email: parsedRes.data.email,
            admin: parsedRes.data.admin,
            worker: parsedRes.data.worker,
            uid: parsedRes.data.uid,
            userRole: parsedRes.data.role,
         }
         dispatch({
            type: "LOGIN",
            payload: {
               user: userInfo,
               uid: userInfo.uid,
               role: userInfo.userRole,
               sessionTime: Date.now() + parsedRes.data.sessionTime,
            },
         })
         if (!isCancelled) {
            setIsPending(false)
            setError(null)
         }
      } catch (error) {
         if (!isCancelled) {
            setIsPending(false)
            setError("Contraseña incorrecta")
         }
      }
   }

   useEffect(() => {
      setIsCancelled(false)
      return () => setIsCancelled(true)
   }, [])

   return {error, setError, isPending, login}
}
